export default __webpack_public_path__ + "static/media/ThreeDots.b092ca73.svg";